import {useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {TwoFactorChallengePage} from '@common/auth/ui/two-factor/two-factor-challenge-page';
import {LoginPage} from '@common/auth/ui/login-page';
import {SsoLoginPage} from '@common/auth/ui/sso-login-page';

export function LoginPageWrapper() {
  const [isTwoFactor, setIsTwoFactor] = useState(false);
  const [searchParams] = useSearchParams();
  if (searchParams.get('bypass_sso') !== '1') {
    return <SsoLoginPage />;
  }
  if (isTwoFactor) {
    return <TwoFactorChallengePage />;
  } else {
    return <LoginPage onTwoFactorChallenge={() => setIsTwoFactor(true)} />;
  }
}
